<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <discount-form></discount-form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import discountForm from './Temp/DiscountForm.vue'
export default {
  components: {
    'discount-form': discountForm
  },
  data () {
    return {
      activityMethod: 1
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>



// WEBPACK FOOTER //
// CrDiscount.vue?2a18eb1a